module.exports = __webpack_public_path__ + "media/images/oxfamc-a3a1457f0eb9b96f16052f2facae9d2f.png";